module.exports = __webpack_public_path__ + "static/media/Food12.b829cf3e.jpg";